import React from 'react';
import styled from 'styled-components';

import { viewerZIndices } from '../../../../viewer/viewer-z-indices';
import { BottomMenuAutoExpandContainer } from './bottom-menu-auto-expand-container';

const BottomMenu = () => {
  return <Component />;
};

const Component = styled(BottomMenuAutoExpandContainer)`
  pointer-events: auto;
  z-index: ${viewerZIndices.menu};
`;

export { BottomMenu };
